if (!customElements.get('load-more')) {
  class LoadMore extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('a[role="button"], button');
      this.button?.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
    }

    async handleClick(e) {
      e.preventDefault();
      this.button.disabled = true;
      this.button.querySelectorAll('.svg-wrapper').forEach(span => {
        span.classList.toggle('hidden');
      });

      const nextPageUrl = this.dataset.nextPageUrl;
      const appendTo = this.dataset.appendTo;
      if (!nextPageUrl || !appendTo) return;
      try {
        const response = await fetch(nextPageUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const toAppend = doc.querySelector(appendTo);
        const target = document.querySelector(appendTo);
        if (toAppend && target) {
          Array.from(toAppend.children).forEach(child => {
            target.appendChild(child);
          });
        }
        // Replace this <load-more> with the new one from the fetched HTML, if present
        const newLoadMore = doc.querySelector('load-more');
        if (newLoadMore) {
          this.replaceWith(newLoadMore);
        } else {
          this.remove();
        }
      } catch (err) {
        console.error('Load more failed', err);
      }
    }
  }
  customElements.define('load-more', LoadMore);
} 